import React, { useEffect } from "react";
import classes from "./api-integration.module.scss";
import { Modal } from "react-bootstrap";

const ApiConsumption = ({ show, setShow, data }) => {
  return (
    <Modal show={show} centered onHide={() => setShow(false)} keyboard={false} size="md" className={classes.api_consume_modal}>
      <Modal.Body>
        <div className="">
          <div className={classes.credits_consume_container}>
            <label>API</label>
            <label>Credits Used</label>
          </div>
        </div>
        <div>
          {data?.credit_usage_details?.map((item) => (
            <div className={`${classes.credits_consume_container} container`}>
              <div>{item?.api_name}</div>
              <div>{item?.credits_used}</div>
            </div>
          ))}
        </div>
        <div className="container pt-2 ps-0">
          <div className="d-flex justify-content-between">
            <div>Total Credits</div>
            <div>{data?.total_credits_consumed}</div>
          </div>
        </div>
      </Modal.Body>
      <div></div>
    </Modal>
  );
};

export default ApiConsumption;
